// extracted by mini-css-extract-plugin
module.exports = {"background":"hero-module--background--2fEy8","text":"hero-module--text--1UU8P","hero_image":"hero-module--hero_image--9GVie"};